export default "__VITE_ASSET__dc30b3e4__"